import { useRef } from 'react';

import { ValidationContext } from './ValidationContext';

export function ValidationProvider({ children }) {
  const validatorsRef = useRef<(() => boolean)[]>([]);

  const registerValidation = (fn: () => boolean) => {
    validatorsRef.current.push(fn);
  };

  const triggerValidation = () => {
    let isValid = true;
    validatorsRef.current.forEach((fn) => {
      if (!fn()) {
        isValid = false;
      }
    });
    return isValid;
  };

  return (
    <ValidationContext.Provider
      value={{
        registerValidation,
        triggerValidation,
      }}
    >
      {children}
    </ValidationContext.Provider>
  );
}
